import React from 'react'
import { Row, Col } from 'reactstrap'
import get from 'lodash/get'
import set from 'lodash/set'
import find from 'lodash/find'
import LeaveHistoryTable from '../../components/my-leave/table/leave-history'
import { Leave, Compensate } from '../../components/my-leave/modal'
import { ConfirmCancel } from '../../components/my-leave/form'
import { changeDataLeaveHistory } from '../../components/my-leave/helpers/my-leave'

export const LeaveHistory = class extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'myLeaveRequests', []) !== prevState.myLeaveRequests
    || get(nextProps, 'myCompensateRequestsHistory', []) !== prevState.myCompensateRequestsHistory
    || get(nextProps, 'myCompensateRequests', []) !== prevState.myCompensateRequests) {
      set(tempState, 'myLeaveRequests', get(nextProps, 'myLeaveRequests'))
      set(tempState, 'myCompensateRequestsHistory', get(nextProps, 'myCompensateRequestsHistory'))
      set(tempState, 'myCompensateRequests', get(nextProps, 'myCompensateRequests'))
      set(tempState, 'requests', changeDataLeaveHistory(
        get(nextProps, 'myLeaveRequests', []),
        get(nextProps, 'myCompensateRequestsHistory', []),
        get(nextProps, 'myCompensateRequests', []),
        get(nextProps, 'leaveTypes', []),
        get(nextProps, 'users', [])
      ))
    }
    return tempState
  }

  state={
    myLeaveRequests: [],
    myCompensateRequestsHistory: [],
    myCompensateRequests: [],
    requests: [],
    showDetail: false,
    showCompensate: false,
    showCancel: false,
  }

  handleClickRow = (id) => {
    const request = find(this.state.requests, {
      _id: id,
    })
    if (request) {
      if (get(request, 'leave_type') !== 'Compensate Work') {
        this.setState({
          showDetail: !this.state.showDetail,
          data: [request],
          requestID: id,
        })
      } else {
        this.setState({
          showCompensate: !this.state.showCompensate,
          data: [request],
          requestID: id,
        })
      }
    }
  }

  render() {
    const cancelLeaveRequest = get(this.props, 'cancelLeaveRequest')
    return (
      <Row>
        <Col>
          <ConfirmCancel
            open={ this.state.showCancel }
            toggle={ () => this.setState({ showCancel: !this.state.showCancel }) }
            handleRemark={ (e) => this.setState({ remark: e.target.value }) }
            clickCancelButton={ (type) => {
              if (type === 'yes') {
                cancelLeaveRequest(
                  this.state.requestID, { remark: this.state.remark }, localStorage.getItem('access_token')
                )
              }
              this.setState({
                showCancel: !this.state.showCancel,
                remark: '',
              })
            } }
          />
          <Leave
            showDetail={ this.state.showDetail }
            handleDetail={ () => this.setState({ showDetail: !this.state.showDetail }) }
            handleClickCancel={ () => {
              this.setState({
                showCancel: !this.state.showCancel,
                showDetail: !this.state.showDetail,
              })
            } }
            data={ this.state.data }
          />
          <Compensate
            showDetail={ this.state.showCompensate }
            handleDetail={ () => this.setState({ showCompensate: !this.state.showCompensate }) }
            data={ this.state.data }
          />
          <LeaveHistoryTable
            handleClickRow={ this.handleClickRow }
            requests={ this.state.requests }
          />
        </Col>
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/my-leave/leave-history.js